import * as requestFromServer from "./HomeworksCrud";
import { callTypes, homeworkSlice } from "./HomeworksSlice";

const {actions} = homeworkSlice;

export const getHomeworks = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getHomeworks(queryParams)
    .then(response => {
      dispatch(actions.homeworksFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllHomeworks = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllHomeworks(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getHomeworkReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getHomeworkReport(queryParams)
    .then(response => {
      dispatch(actions.homeworksFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllHomeworkReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllHomeworkReport(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getAllList = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllList()
    .then(response => {
      dispatch(actions.allListFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getList = term => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getList(term)
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getStudents = (term, sectionId) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getStudents(term, sectionId)
    .then(response => {
      dispatch(actions.studentsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getHomeworkReceipents = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getHomeworkReceipents(queryParams)
    .then(response => {
      dispatch(actions.homeworksFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllHomeworkReceipents = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllHomeworkReceipents(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getHomeworkDetail = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getHomeworkDetail(id)
    .then(response => {
      dispatch(actions.homeworkFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const downloadAttachment = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
  .downloadAttachment(id)
  .then(response => {
    dispatch(actions.actionCompleted());
    return response.data;
  })
  .catch(error => {
    dispatch(actions.actionCompleted());
  });
};

export const cleanStudentsState = () => dispatch => {
  dispatch(actions.studentsStateCleaned());
}

export const cleanHomeworkState = () => dispatch => {
  dispatch(actions.homeworkStateCleaned());
};

export const cleanHomeworksState = () => dispatch => {
  dispatch(actions.homeworksStateCleaned());
};